var map = {
	"./0/diamond/1.png": 24065,
	"./0/diamond/2.png": 51800,
	"./0/diamond/3.png": 29417,
	"./0/diamond/4.png": 56325,
	"./0/diamond/5.png": 75171,
	"./0/diamond/6.png": 37141,
	"./0/diamond/7.png": 22735,
	"./0/diamond/8.png": 22749
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28484;